import { ApolloClient } from '@apollo/client/core';
import { defineStore } from 'pinia';

import type { Currency, Language } from '../graphql';
import { CurrenciesDocument, LanguagesDocument } from '../graphql';

type State = {
  _currencies: Currency[];
  _languages: Language[];
};

type Getters = {
  currencies(): Currency[];
  languages(): Language[];
};

type Actions = {
  fetchCurrencies(client: ApolloClient<object>): Promise<Currency[]>;
  fetchLanguages(client: ApolloClient<object>): Promise<Language[]>;
};

export const useReferentialStore = defineStore<
  'referential',
  State,
  Getters,
  Actions
>('referential', {
  actions: {
    async fetchCurrencies(client) {
      const { data } = await client.query({ query: CurrenciesDocument });

      this._currencies = data.currencies as Currency[];

      return this._currencies;
    },
    async fetchLanguages(client) {
      const { data } = await client.query({ query: LanguagesDocument });

      const val = [...data.languages];

      // add language codes which are absent in accor db
      val.push({ code: 'ta', label: 'தமிழ்', __typename: 'Language' }); // Tamil
      val.push({ code: 'kk', label: 'қазақ', __typename: 'Language' });
      val.push({ code: 'dt', label: 'Dutch', __typename: 'Language' });
      val.push({ code: 'he', label: 'עִברִית', __typename: 'Language' }); // Hebrew
      val.push({ code: 'ta', label: 'แบบไทย', __typename: 'Language' }); // Thai
      val.push({ code: 'uk', label: 'Українська', __typename: 'Language' });
      val.push({ code: 'ro', label: 'Română', __typename: 'Language' });
      val.push({ code: 'hi', label: 'हिंदी', __typename: 'Language' }); // Hindi

      this._languages = val;
      return this._languages;
    },
  },
  getters: {
    currencies() {
      return this._currencies;
    },
    languages() {
      return this._languages;
    },
  },
  state() {
    return {
      _currencies: [],
      _languages: [],
    };
  },
});
